import { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../AccountContext';
import { useToast } from '@chakra-ui/react';

const useViewHistorico = () => {
  const { user, setPage } = useContext(AccountContext);
  const [atestados, setAtestados] = useState([]);
  const [receitas, setReceitas] = useState([]);
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [loadinreSend, setLoadingResend] = useState(false);
  const [loading, setLoading] = useState(false);
  const [medicos, setMedicos] = useState([]);
  const toast = useToast();

  function showToast(title, description, status, color) {
    toast({
      title: title,
      description: description,
      status: status,
      duration: 4000,
      isClosable: true,
      position: 'bottom',
      colorScheme: color,
      containerStyle: {
        paddingTop: '50px',
      },
    });
  }

  const ENDPOINT_DEOVITA =
    process.env.REACT_APP_ENVIRONMENT !== 'production' ? process.env.REACT_APP_URL_DEOVITA_PROD : process.env.REACT_APP_URL_DEOVITA_TEST;

  async function fetchDocumentos(ambulatorioLaudoId) {
    if (!ambulatorioLaudoId) {
      throw new Error('Não foi identificado número do laudo');
    }

    try {
      const response = await fetch(`${ENDPOINT_DEOVITA}/deovita/autocomplete/retrievePrescriptionAssignatureUrlsForLaudoId/${ambulatorioLaudoId}`);
      console.log('response ', await response.json());
      //return await response.json();
    } catch (err) {
      throw new Error(`Não foi possível carregar documentos do laudo "${ambulatorioLaudoId}": ${err.message}`);
    }
  }

  function fetchMedicos() {
    fetch(`${process.env.REACT_APP_BASE_URL_API_SERVER}/clients/selectOperatorCompany/${user.empresa_id}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .catch((err) => {
        console.log(err);
        return;
      })
      .then((response) => {
        if (!response || !response.ok || response.status >= 400) {
          return;
        }
        return response.json();
      })
      .then((result) => {
        setMedicos(result.data);
      });
  }

  async function fetchAtestados(userCpf) {
    try {
      fetch(
        `${process.env.REACT_APP_BASE_URL_API_SERVER}/clients/getHistoricoAtestados/${user?.perfil_id === 4 ? user?.username : userCpf}/${
          user.empresa_id
        }`,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
        .catch((err) => {
          console.log(err);
          return;
        })
        .then((response) => {
          if (!response || !response.ok || response.status >= 400) {
            return;
          }
          return response.json();
        })
        .then(async (result) => {
          setAtestados(result?.data?.data);
        });
    } catch (error) {
      throw new Error(error);
    }
  }

  function fetchReceitas(userId) {
    fetch(
      `${process.env.REACT_APP_BASE_URL_API_SERVER}/clients/getHistoricoReceitas/${user.perfil_id === 4 ? user.username : userId}/${user.empresa_id}`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
      .catch((err) => {
        console.log(err);
        return;
      })
      .then((response) => {
        if (!response || !response.ok || response.status >= 400) {
          return;
        }
        return response.json();
      })
      .then(async (result) => {
        setReceitas(result?.data?.data);
      });
  }

  function fetchSolicitacoes(userId) {
    fetch(
      `${process.env.REACT_APP_BASE_URL_API_SERVER}/clients/getEstimateWorked/${user.perfil_id === 4 ? user.username : userId}/${user.empresa_id}`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
      .catch((err) => {
        console.log(err);
        return;
      })
      .then((response) => {
        if (!response || !response.ok || response.status >= 400) {
          return;
        }
        return response.json();
      })
      .then(async (result) => {
        setSolicitacoes(result?.data?.data);
      });
  }

  async function fetchDocs(laudoId) {
    try {
      const response = await fetch(`${ENDPOINT_DEOVITA}/deovita/autocomplete/retrievePrescriptionAssignatureUrlsForLaudoId/${laudoId}`);
      //console.log("response ", await response.json())
      return await response.json();
    } catch (err) {
      throw new Error(`Não foi possível carregar documentos do laudo "${laudoId}": ${err.message}`);
    }
  }

  async function reenviarAtestados(laudoId, paciente, whatsapp, medico) {
    if (!laudoId) {
      throw new Error('Não foi identificado número do laudo');
    }

    try {
      setLoadingResend(true);
      const dados = await fetchDocs(laudoId);
      if (dados?.Atestado_assinado?.length) {
        const link = dados?.Atestado_assinado?.at(0);
        fetch(`${process.env.REACT_APP_BASE_URL_API_SERVER}/clients/reSendAtestado/`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            laudoId,
            link,
            paciente,
            whatsapp,
            medico,
          }),
        }).then(async (resposta) => {
          setLoadingResend(false);
          if (resposta.status === 200) {
            showToast('Sucesso!', `Atestado reenviado com sucesso`, 'success', 'green');
          }
        });
      }
    } catch (error) {
      setLoadingResend(false);
      showToast('Falha ao reenviar atestado', `Aconteceu um problema ao reenviar o atestado`, 'error', 'red');
      throw new Error(error);
    }
  }

  useEffect(() => {
    setLoading(true);
    fetchMedicos();
    fetchAtestados();
    fetchReceitas();
    fetchSolicitacoes();
    setLoading(false);
  }, []);

  return {
    fetchAtestados,
    atestados,
    setAtestados,
    receitas,
    setReceitas,
    fetchReceitas,
    fetchSolicitacoes,
    medicos,
    setMedicos,
    fetchMedicos,
    solicitacoes,
    setSolicitacoes,
    loading,
    setLoading,
    fetchDocumentos,
    reenviarAtestados,
    loadinreSend, 
    setLoadingResend
  };
};

export default useViewHistorico;
